import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { getPartnerPrimaryColor } from 'common/styles/organisationPartnerTheme';

// A trend line that breaks off into a dashed gap with a spark where it broke:
// "this data view stopped", in the product's own visual language.
const BrokenTrendIllustration = ({ width, theme }) => {
  const { colors } = theme;
  const accent = getPartnerPrimaryColor(theme);
  return (
    <svg width={width} height={width * 0.5} viewBox="0 0 120 60" fill="none" aria-hidden="true">
      <line x1="6" y1="52" x2="114" y2="52" stroke={colors.greyL} strokeWidth="1.5" strokeLinecap="round" />
      <polyline points="8,42 24,30 38,37 56,17" stroke={accent} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <polyline points="68,23 82,31 96,15 112,24" stroke={colors.greyD} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="1 6" />
      <path d="M62 9 L64 16 L71 18 L64 20 L62 27 L60 20 L53 18 L60 16 Z" fill={colors.errorRed} />
    </svg>
  );
};

BrokenTrendIllustration.propTypes = {
  width: PropTypes.number,
  theme: PropTypes.object.isRequired
};

BrokenTrendIllustration.defaultProps = {
  width: 120
};

export default withTheme(BrokenTrendIllustration);
